module.exports = __webpack_public_path__ + "img/emoji_24.a7af11a5.png";